<template>
  <div class="lds-ellipsis">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
import './moreInformationLoader.scss';

export default {
  name: "MoreInformationLoader",
};
</script>
